import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import SEO from '../components/SEO';
import './LegalPages.css';

const PrivacyPolicy = () => {
  return (
    <div className="legal-page">
      <SEO 
        title="Privacy Policy | The Prisma Global"
        description="Privacy policy explaining how The Prisma Global collects, uses, and protects your personal information."
        canonical="/privacy-policy"
      />
      <Navbar />
      
      <div className="legal-content">
        <div className="legal-container">
          <h1>Privacy Policy</h1>
          <p className="last-updated">Last Updated: December 23, 2025</p>
          
          <section>
            <h2>1. Introduction</h2>
            <p>The Prisma Global ("we," "our," or "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website or use our services.</p>
          </section>

          <section>
            <h2>2. Information We Collect</h2>
            <h3>Personal Information</h3>
            <p>We collect information that you provide directly to us:</p>
            <ul>
              <li>Name</li>
              <li>Email address</li>
              <li>Phone number</li>
              <li>Company name</li>
              <li>Payment information (processed securely through Cashfree)</li>
              <li>Communication preferences</li>
            </ul>
            
            <h3>Automatically Collected Information</h3>
            <ul>
              <li>IP address</li>
              <li>Browser type and version</li>
              <li>Device information</li>
              <li>Pages visited and time spent</li>
              <li>Referring website</li>
              <li>Geographic location (city/country level)</li>
            </ul>
          </section>

          <section>
            <h2>3. How We Use Your Information</h2>
            <p>We use collected information for:</p>
            <ul>
              <li>Processing transactions and delivering products/services</li>
              <li>Sending Impact Reports and order confirmations</li>
              <li>Responding to inquiries and providing customer support</li>
              <li>Improving our website and services</li>
              <li>Sending marketing communications (with your consent)</li>
              <li>Analyzing website usage and trends</li>
              <li>Complying with legal obligations</li>
            </ul>
          </section>

          <section>
            <h2>4. Information Sharing</h2>
            <p>We do not sell your personal information. We may share information with:</p>
            <ul>
              <li><strong>Service Providers:</strong> Cashfree (payment processing), email services, hosting providers</li>
              <li><strong>Analytics:</strong> Google Analytics (anonymized data)</li>
              <li><strong>Legal Requirements:</strong> When required by law or to protect our rights</li>
            </ul>
          </section>

          <section>
            <h2>5. Data Security</h2>
            <p>We implement appropriate security measures to protect your information:</p>
            <ul>
              <li>SSL/TLS encryption for data transmission</li>
              <li>Secure payment processing through Cashfree</li>
              <li>Regular security audits</li>
              <li>Access controls and authentication</li>
              <li>Data backup and recovery systems</li>
            </ul>
            <p>However, no method of transmission over the internet is 100% secure.</p>
          </section>

          <section>
            <h2>6. Cookies & Tracking Technologies</h2>
            <p>We use cookies and similar technologies to:</p>
            <ul>
              <li>Remember your preferences</li>
              <li>Analyze site traffic and usage</li>
              <li>Personalize content and ads</li>
            </ul>
            <p>You can control cookies through your browser settings. Note that disabling cookies may affect website functionality.</p>
          </section>

          <section>
            <h2>7. Third-Party Links</h2>
            <p>Our website may contain links to third-party websites. We are not responsible for the privacy practices of these external sites. Please review their privacy policies separately.</p>
          </section>

          <section>
            <h2>8. Your Rights</h2>
            <p>You have the right to:</p>
            <ul>
              <li>Access your personal information</li>
              <li>Correct inaccurate data</li>
              <li>Request deletion of your data</li>
              <li>Opt-out of marketing communications</li>
              <li>Object to data processing</li>
              <li>Data portability</li>
            </ul>
            <p>To exercise these rights, contact us at info@theprismaglobal.com</p>
          </section>

          <section>
            <h2>9. Children's Privacy</h2>
            <p>Our services are not directed to individuals under 18 years of age. We do not knowingly collect personal information from children.</p>
          </section>

          <section>
            <h2>10. Data Retention</h2>
            <p>We retain your information for as long as necessary to:</p>
            <ul>
              <li>Provide our services</li>
              <li>Comply with legal obligations</li>
              <li>Resolve disputes</li>
              <li>Enforce our agreements</li>
            </ul>
            <p>Typically, transaction data is retained for 7 years for accounting and tax purposes.</p>
          </section>

          <section>
            <h2>11. International Data Transfers</h2>
            <p>Your information may be transferred to and processed in locations outside India. We ensure appropriate safeguards are in place to protect your data in accordance with this Privacy Policy.</p>
          </section>

          <section>
            <h2>12. Changes to Privacy Policy</h2>
            <p>We may update this Privacy Policy from time to time. Changes will be posted on this page with an updated revision date. Continued use of our services constitutes acceptance of the updated policy.</p>
          </section>

          <section>
            <h2>13. Contact Us</h2>
            <p>For privacy-related questions or concerns:</p>
            <p>
              <strong>The Prisma Global</strong><br />
              Next to Markanday Mandir, Kumtha Naka<br />
              Solapur 413001, Maharashtra, India
            </p>
            <p>
              Email: info@theprismaglobal.com<br />
              Phone: +91-9356-107-460
            </p>
          </section>

          <section>
            <h2>14. Compliance</h2>
            <p>This Privacy Policy is designed to comply with:</p>
            <ul>
              <li>Information Technology Act, 2000 (India)</li>
              <li>Information Technology (Reasonable Security Practices) Rules, 2011</li>
              <li>General Data Protection Regulation (GDPR) principles where applicable</li>
            </ul>
          </section>
        </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default PrivacyPolicy;